import Vue from 'vue'
import Router from 'vue-router'
import login from '@/page/login/login'
import modify from '@/page/login/password'
import home from '@/page/home/index'
import detail from '@/page/product/index'
import list from '@/page/product/list'
import outbatchdetail from '@/page/product/outbatchdetail'
import matchsdetail from '@/page/product/matchsdetail'

import shopcart from '@/page/shopcart/shopcart'
import outbatch from '@/page/shopcart/outbatch'
import shopbatch from '@/page/shopcart/shopbatch'
import shopmatchs from '@/page/shopcart/shopmatchs'
import order from '@/page/order/index'
import orderdetail from '@/page/order/orderdetail'

import home1 from '@/page/home/default'
import prolist from '@/page/home/list'
import prolistdis from '@/page/home/listdis'
import bestlist from '@/page/home/bestlist'
import banner from '@/page/home/banner'

import picklist from '@/page/picklist/index'
import picklistdetail from '@/page/picklist/detail'
Router.options = { showVuxVersionInfo: false }
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/modify',
      name: 'modify',
      component: modify
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        title: '采购商城',
        keepAlive: true ,
      }
    },
    {
      path: '/home1',
      name: 'home1',
      component: home1,
      meta: {
        keepAlive: true 
      }
    },
    {
      path: '/prolist/:type/:id',
      name: 'prolist',
      component: prolist,
      meta: {
        keepAlive: true ,
        // title: '现货抢购',
      }
    },
    {
      path: '/prolistdis/:type/:id',
      name: 'prolistdis',
      component: prolistdis,
      meta: {
        keepAlive: true ,
        // title: '常规现货',
      }
    },
    {
      path: '/bestlist/:type/:id',
      name: 'bestlist',
      component: bestlist,
      meta: {
        keepAlive: true ,
        // title: '畅销推荐',
      }
    },
    {
      path: '/banner/:id',
      name: 'banner',
      component: banner,
      meta: {
        keepAlive: true ,
      }
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: detail
    },
    {
      path: '/outbatchdetail/:type/:id',
      name: 'outbatchdetail',
      component: outbatchdetail
    },
    {
      path: '/matchsdetail/:type/:id',
      name: 'matchsdetail',
      component: matchsdetail
    },
    {
      path: '/list/:id',
      name: 'list',
      component: list
    },
    {
      path: '/shopcart',
      name: 'shopcart',
      component: shopcart,
      meta: {
        title: '购物车',
        // keepAlive: true ,
      }
    },
    {
      path: '/shopbatch/:cid/:id',
      name: 'shopbatch',
      component: shopbatch
    },
    {
      path: '/shopmatchs/:type/:cid/:id',
      name: 'shopmatchs',
      component: shopmatchs
    },
    {
      path: '/outbatch/:type/:cid/:id',
      name: 'outbatch',
      component: outbatch
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: '我的订单',
        keepAlive: true ,
      }
    },
    {
      path: '/orderdetail/:id',
      name: 'orderdetail',
      component: orderdetail
    },
    {
      path: '/picklist',
      name: 'picklist',
      component: picklist,
      meta: {
        title: '展厅挑货',
        keepAlive: true ,
      }
    },
    {
      path: '/picklistdetail/:id',
      name: 'picklistdetail',
      component: picklistdetail,
      meta: {
        title: '挑货单详情',
        keepAlive: true ,
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js